export const MOBILE_CAROUSEL_CLASSNAME_SELECTOR = '.c-set-of-cards.c-set-of-cards--P3B.u-hidden-d';
export const SECTION_TITLE_CLASSNAME = 'c-section-title';
